import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ShopifyActions from '../../actions/tools/ShopifyActions';
import * as ZendeskActions from '../../actions/tools/ZendeskActions';
import * as ToolActions from '../../actions/tools/ToolActions';
import * as OrdersSearchActions from '../../actions/tools/OrdersSearchActions';
import CommonSelectTask from '../../components/tools/CommonSelectTask/CommonSelectTask';

const TASK_INPUTS = [
  {
    id: 'refundOrder',
    title: 'Refund Order',
  },
  {
    id: 'cancelOrder',
    title: 'Cancel Order',
  },
];

function mapStateToProps(state) {
  return {
    taskInputs: TASK_INPUTS,
    selectedToolDomains: Object.assign({}, state.tools.general.selectedToolDomains),
  };
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    Object.assign({}, ShopifyActions, ZendeskActions, ToolActions, OrdersSearchActions),
    dispatch
  );
};

const MockSelectTaskContainer = connect(mapStateToProps, mapDispatchToProps)(CommonSelectTask);

export default MockSelectTaskContainer;
